// Top 100 most-used GCP Terraform resources based on industry standards
export const gcpTop100Whitelist = [
  // Compute
  "google_compute_instance",
  "google_compute_instance_template",
  "google_compute_instance_group",
  "google_compute_instance_group_manager",
  "google_compute_autoscaler",
  "google_compute_disk",
  "google_compute_snapshot",
  "google_compute_image",
  "google_container_cluster",
  "google_container_node_pool",
  "google_cloudfunctions_function",
  "google_cloudfunctions2_function",
  "google_cloud_run_service",
  "google_cloud_run_v2_service",
  "google_app_engine_application",
  "google_app_engine_standard_app_version",

  // Storage
  "google_storage_bucket",
  "google_storage_bucket_object",
  "google_storage_bucket_iam_member",
  "google_storage_bucket_iam_policy",
  "google_filestore_instance",
  "google_compute_resource_policy",

  // Database
  "google_sql_database_instance",
  "google_sql_database",
  "google_sql_user",
  "google_bigtable_instance",
  "google_bigtable_table",
  "google_spanner_instance",
  "google_spanner_database",
  "google_firestore_database",
  "google_firestore_document",
  "google_redis_instance",
  "google_memcache_instance",

  // Networking
  "google_compute_network",
  "google_compute_subnetwork",
  "google_compute_firewall",
  "google_compute_router",
  "google_compute_router_nat",
  "google_compute_vpn_gateway",
  "google_compute_vpn_tunnel",
  "google_compute_address",
  "google_compute_global_address",
  "google_compute_forwarding_rule",
  "google_compute_global_forwarding_rule",
  "google_compute_backend_service",
  "google_compute_backend_bucket",
  "google_compute_health_check",
  "google_compute_http_health_check",
  "google_compute_https_health_check",
  "google_compute_url_map",
  "google_compute_target_http_proxy",
  "google_compute_target_https_proxy",
  "google_compute_ssl_certificate",
  "google_compute_managed_ssl_certificate",
  "google_dns_managed_zone",
  "google_dns_record_set",
  "google_compute_interconnect_attachment",
  "google_compute_network_peering",
  "google_compute_route",
  "google_compute_security_policy",
  "google_network_connectivity_hub",

  // Security
  "google_project_iam_member",
  "google_project_iam_binding",
  "google_project_iam_policy",
  "google_service_account",
  "google_service_account_key",
  "google_service_account_iam_member",
  "google_kms_key_ring",
  "google_kms_crypto_key",
  "google_kms_crypto_key_iam_member",
  "google_secret_manager_secret",
  "google_secret_manager_secret_version",
  "google_compute_ssl_policy",
  "google_iap_web_iam_member",
  "google_identity_platform_config",

  // Analytics
  "google_bigquery_dataset",
  "google_bigquery_table",
  "google_bigquery_job",
  "google_dataflow_job",
  "google_dataproc_cluster",
  "google_pubsub_topic",
  "google_pubsub_subscription",
  "google_composer_environment",
  "google_data_fusion_instance",
  "google_datastream_stream",

  // DevOps
  "google_cloudbuild_trigger",
  "google_artifact_registry_repository",
  "google_container_registry",
  "google_sourcerepo_repository",
  "google_clouddeploy_delivery_pipeline",

  // Monitoring
  "google_logging_project_sink",
  "google_logging_folder_sink",
  "google_logging_organization_sink",
  "google_monitoring_alert_policy",
  "google_monitoring_notification_channel",
  "google_monitoring_dashboard",
  "google_monitoring_uptime_check_config",

  // AI/ML
  "google_vertex_ai_dataset",
  "google_vertex_ai_endpoint",
  "google_vertex_ai_featurestore",
  "google_notebooks_instance",
  "google_ml_engine_model",

  // Management
  "google_project",
  "google_folder",
  "google_organization_policy",
  "google_project_service",
  "google_resource_manager_lien",

  // Billing
  "google_billing_account_iam_member",
  "google_billing_budget",

  // Other
  "google_compute_project_metadata",
  "google_compute_project_metadata_item",
  "google_apikeys_key",
  "google_vpc_access_connector",
  "google_endpoints_service",
  "google_compute_region_backend_service",
  "google_compute_target_pool",
  "google_compute_instance_iam_member",
  "google_folder_iam_member",
  "google_organization_iam_member",
] as const;

export type GcpTop100Tf = (typeof gcpTop100Whitelist)[number];
